import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { debounceTime, Subscription } from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FilterPipe } from '@shared/pipes/filter.pipe';
import { SwiperComponent } from 'swiper/angular';

@Component({
 selector: 'iho-map-hotel-searchbox',
 standalone: true,
 imports: [CommonModule, SharedModule, ReactiveFormsModule, FilterPipe],
 templateUrl: './map-hotel-searchbox.component.html',
 styleUrls: ['./map-hotel-searchbox.component.scss'],
})
export class MapHotelSearchboxComponent {
 @Input() dataSource: any[] = [];
 @Output() onSelectItem = new EventEmitter<any>();
 showResults = false;
 searchControl = new FormControl('');
 filterSubscription!: Subscription;
 filterText = '';


 constructor() {
  this.controlChangeAndFilter();
 }

 controlChangeAndFilter() {
  this.filterSubscription = this.searchControl.valueChanges
   .pipe(debounceTime(300))
   .subscribe((value) => {
    this.filterText = value ?? '';
   });
 }

 selectItem(hotel: any) {
  this.showResults = false;
  this.searchControl.setValue(hotel.HotelName);
  this.onSelectItem.emit(hotel);
 }

 @HostListener('document:click', ['$event'])
 onOutsideClicked(event: any): void {
  const targetEl = event.target as HTMLElement;
  if (!targetEl.closest('.searchBoxInput') && !targetEl.closest('.searchSuggestBox')) {
   this.showResults = false;
  }
 }
}
